// Export all test suites for the vision plugin
export { default as VisionBasicE2ETestSuite } from './tests/e2e/vision-basic';
export { default as VisionAutonomyE2ETestSuite } from './tests/e2e/vision-autonomy';
export { testSuites as default } from './tests/e2e/index';
